<template>
  <div ref="wrapper" class="fd__wrapper" id="scrollTarget">
    <v-text-field
      :loading="loading"
      :label="name"
      ref="textBox"
      type="text"
      id="selectedTextBox"
      class="fd__display-textbox"
      style="height: 50px;"
      :disabled="disabled"
      :value="displayText"
      :placeholder="placeholder"
      readonly="readonly"
      append-icon="mdi-menu-down"
      @click="textBoxClicked"
    >
    </v-text-field>
    <div v-show="showList">
      <v-list
        max-height="400px"
        elevation="1"
        dense
        style="overflow-y:scroll;overflow-x:hidden;"
      >
        <span>
          <v-list-item>
            <v-text-field
              ref="filterTextBox"
              type="text"
              class="fd__filter-textbox"
              placeholder="Filter..."
              v-model="filterString"
            ></v-text-field>
          </v-list-item>
        </span>
        <span>
          <v-list-item
            class="pa-1"
            v-if="showEmptyItem"
            :value="emptyItemValue"
            @click.stop.prevent="itemClicked(null)"
            >{{ emptyItemText || '&nbsp;' }}
          </v-list-item>
        </span>
        <span v-if="filteredItems.length > 0">
          <v-list-item
            v-for="item in filteredItems"
            :key="'item_' + (idKey ? item[idKey] : item)"
            :value="valueKey ? item[valueKey] : item"
            :disabled="item.disabled ? item.disabled : false"
            class="hotel_list"
            @click.stop.prevent="itemClicked(item)"
          >
            {{
              textKey
                ? item[`${textKey}_${localeKey}`] || item[textKey] || item
                : item
            }}
          </v-list-item>
        </span>
        <v-list-item v-if="filteredItems.length === 0">
          {{ $t('text_0ueq') }}
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterString: null,
      showList: false,
      category: 0,
    };
  },
  props: {
    name: { type: String, default: '' },
    value: {
      type: [String, Number, Boolean, Date, Object, Array],
      default: null,
    },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    showEmptyItem: { type: Boolean, default: false },
    emptyItemText: { type: String, default: null },
    emptyItemValue: { type: String, default: null },
    items: { type: Array, default: null },
    idKey: { type: String, default: null },
    valueKey: { type: String, default: null },
    textKey: { type: String, default: null },
    localeKey: { type: String, default: null },
    filterTargetKey: { type: String, default: null },
    filterTargetKanaKey: { type: String, default: null },
    ignoreCase: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
  },
  computed: {
    categoryList() {
      return [
        { id: 0, label: this.$t('all') },
        { id: 1, label: this.$t('love_hotel') },
        { id: 2, label: this.$t('rental_room') },
        { id: 3, label: this.$t('business_city_hotel') },
      ];
    },
    categoryFilterItems() {
      let items = [];
      if (this.loading) {
      } else {
        if (this.category === 0) {
          items = this.items;
        } else {
          items = this.items.filter((v) => v.category === this.category);
        }
      }
      return items;
    },
    filteredItems() {
      if (!this.categoryFilterItems || this.categoryFilterItems.length === 0)
        return [];
      if (!this.filterString) return this.categoryFilterItems;
      const flags = this.ignoreCase ? 'i' : '';
      const regexp = new RegExp(this.filterString, flags);
      return this.categoryFilterItems.filter((x) => {
        const targetValue = this.filterTargetKey
          ? x[this.filterTargetKey]
          : JSON.stringify(x);
        const targetHiraValue = this.filterTargetKanaKey
          ? x[this.filterTargetKanaKey]
          : JSON.stringify(x);
        const targetKanaValue = targetHiraValue.replace(
          /[\u3041-\u3096]/g,
          function(match) {
            var chr = match.charCodeAt(0) + 0x60;
            return String.fromCharCode(chr);
          }
        );
        if (
          regexp.test(targetValue) ||
          regexp.test(targetHiraValue) ||
          regexp.test(targetKanaValue)
        ) {
          return true;
        } else {
          return false;
        }
        //return regexp.test(targetValue);
      });
    },
    selectedItem() {
      return this.items.find(
        (x) => this.value === (this.valueKey ? x[this.valueKey] : x)
      );
    },
    displayText() {
      const item = this.selectedItem;
      if (this.localeKey === null) {
        if (this.$i18n.locale === 'zh-cn') {
          this.localeKey = 'zh_cn'
        } else if (this.$i18n.locale === 'zh-tw') {
          this.localeKey = 'zh_tw'
        } else if (this.$i18n.locale === 'ko') {
          this.localeKey = 'ko'
        } else {
          this.localeKey = 'en'
        }
      }
      if (!item) return '';
      return this.textKey
        ? item[this.textKey + '_' + this.localeKey] ||
            item[this.textKey] ||
            item
        : item;
    },
  },
  methods: {
    textBoxClicked() {
      if (this.disabled) return;
      this.showList = !this.showList;
    },
    itemClicked(item) {
      if (item) {
        const value = this.valueKey ? item[this.valueKey] : item;
        this.$emit('input', value);
        this.$emit('emitChangeHotel');
      } else {
        this.$emit('input', this.emptyItemValue || null);
        this.$emit('emitChangeHotel');
      }
      this.reset();
    },
    reset() {
      this.showList = false;
      this.filterString = '';
    },
  },
  watch: {
    showList(val) {
      this.$nextTick(() => {
        if (val) {
          //
        }
      });
    },
  },
  mounted() {
    const $this = this;
    const hotelListShow = document.getElementById('selectedTextBox');
    if (
      $this.$router.currentRoute &&
      $this.$router.currentRoute.path !== '/call/search'
    ) {
      hotelListShow.addEventListener('click', function(e) {
        const target = (e.target || e.srcElement).closest('.fd__wrapper');
        if (target === $this.$refs.wrapper) {
          if (e.target.id === 'selectedTextBox') {
            $this.$refs.textBox.focus();
            setTimeout(function() {
              let element = document.getElementById('scrollTarget');
              let topTarget =
                element.getBoundingClientRect().top + window.pageYOffset - 50;
              if (
                !$this.$store.state.castDialog.selectedCastReserveDialog &&
                ($this.$store.state.castDialog.selectedCastProfileDialog ||
                  $this.$router.currentRoute.name == 'cast-id')
              ) {
                element.scrollIntoView(true);
              } else {
                window.scrollTo({ top: topTarget, behavior: 'smooth' });
              }
            }, 200);
          }
          return;
        }
        $this.reset();
      });
    } else {
      document.addEventListener('click', function(e) {
        const target = (e.target || e.srcElement).closest('.fd__wrapper');
        if (target === $this.$refs.wrapper) {
          if (e.target.id === 'selectedTextBox') {
            $this.$refs.textBox.focus();
            setTimeout(function() {
              let element = document.getElementById('scrollTarget');
              let topTarget =
                element.getBoundingClientRect().top + window.pageYOffset - 50;
              window.scrollTo({ top: topTarget, behavior: 'smooth' });
            }, 200);
          }
          return;
        }
        $this.reset();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.fd__wrapper {
  position: relative;
  * {
    font-size: 1rem;
  }
  input.fd__display-textbox,
  input.fd__filter-textbox {
    width: 100%;
  }
  // .fd__list {
  //   position: absolute;
  //   z-index: 1;
  //   top: 100%;
  //   left: 0;
  //   width: 100%;
  //   padding: 2px;
  //   border: solid 1px rgb(192, 192, 192);
  //   background: white;
  //   box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);
  //   margin-top: -1px;
  //   ul {
  //     margin: 4px 0 0 0;
  //     padding: 2px;
  //     overflow-x: auto;
  //     overflow-y: scroll;
  //     max-height: 20vh;
  //     li {
  //       padding: 2px 1px;
  //       cursor: pointer;
  //       list-style: none;
  //       line-height: 1;
  //       &.fd__item:hover {
  //         background: rgb(250, 114, 196);
  //       }
  //     }
  //   }
  // }
  .usr-call-search-cond__btn {
    font-size: 11px;
    font-weight: bold;
    color: var(--read-font-color-sub);
    box-shadow: 0 1.5px 1.5px 0 rgba(0, 0, 0, 0.1),
      0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 2px 1px -2px rgba(0, 0, 0, 0.2) !important;
  }
  .v-btn--active {
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 2px 1px -2px rgba(0, 0, 0, 0.2) !important;
    color: var(--main-color) !important;
  }
}
div[aria-disabled='true'] {
  background: #696969;
  color: #fff;
}
</style>
